import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LoadingStatus } from '@mp/shared/domain';

import { HitList } from '../models';

import { HitListsActions } from './hitlists.actions';
import { selectHitLists, selectHitListsStatus } from './hitlists.selectors';

@Injectable()
export class HitListsFacade {
  private readonly hitListsStatus$: Observable<LoadingStatus> = this.store$.select(selectHitListsStatus);

  readonly hitListsLoading$: Observable<boolean> = this.hitListsStatus$.pipe(
    map((status) => status === LoadingStatus.Loading),
  );

  readonly hitLists$: Observable<HitList[]> = this.store$.select(selectHitLists);

  constructor(private readonly store$: Store) {}

  fetchHitLists(): void {
    this.store$.dispatch(HitListsActions.fetchHitLists());
  }
}
